import { z } from 'zod/v4';

/**
 * Use this to preprocess Date objects and convert them to ISO strings
 * @returns Zod preprocessor that accepts a Date and returns an ISO string
 */
export function dateToISOStringPreprocessor() {
  return z.preprocess((value) => {
    if (value instanceof Date) {
      return value.toISOString();
    }
    return value;
  }, z.string());
}
